export interface AppEnvironment {
  production: boolean;
  name: string;
  baseUrl: string;
  pdfServiceBaseurl: string;
  ws: string;
  gpsWs: string;
  cashflowsBaseUrl: string;
  getwayBaseUrl: string;
  administrativoBaseUrl: string;
  keycloakUrl: string;
  /** Área de trabajo de Distribución; los repartidores se filtran por este id. */
  distribucionWorkareaId: number;
}

declare global {
  interface Window {
    __env?: Partial<AppEnvironment>;
  }
}

const defaults: AppEnvironment = {
  production: false,
  name: 'development',
  baseUrl: 'https://ms-mb-gateway-ws-nest.apps.dev-bl.crowngroup.com.mx/api',
  pdfServiceBaseurl: 'http://localhost:3001',
  ws: 'https://ms-mb-gateway-ws-nest.apps.dev-bl.crowngroup.com.mx',
  gpsWs: 'https://lnxawsp.gps.swisscrown.com.mx',
  cashflowsBaseUrl: 'https://sc-cashflow-gateway-nest.apps.prod.swisscrown.com.mx',
  getwayBaseUrl: 'https://ms-mb-gateway-ws-nest.apps.dev-bl.crowngroup.com.mx/api',
  administrativoBaseUrl: 'https://ms-mb-gateway-ws-nest.apps.dev-bl.crowngroup.com.mx/api',
  keycloakUrl: 'https://sc-mb-sso.qa.swisscrown.com.mx/',
  distribucionWorkareaId: 18,
};

const runtime = (typeof window !== 'undefined' && window.__env) || {};

export const environment: AppEnvironment = {
  ...defaults,
  ...runtime,
};
